import type { UnlikelyProduct } from "@unlikelystudio/commerce-connector"

import type { Nullish } from "~/@types/generics"
import { PRODUCTS_PER_PAGE } from "~/components/ui/Collection/CollectionDefault/constants"
import { serializeProductCard } from "~/components/ui/Product/ProductCard/_data/serializer"
import type { PushEditoFromSchema } from "~/components/ui/PushEdito/_data/schema"
import serializePushEdito from "~/components/ui/PushEdito/_data/serializer"
import { insertItemsByIndex } from "~/utils/insert-items-by-index"

export async function serializeProductsAndPushesFromCurrentPage({
  products,
  pushesEditoInCurrentPage,
  currentPage,
  locale,
  isFiltering = false,
}: {
  products: UnlikelyProduct[]
  pushesEditoInCurrentPage: PushEditoFromSchema[]
  currentPage: number
  locale: Nullish<string>
  isFiltering?: boolean
}) {
  // If we are filtering, we don't need to serialize pushesEdito
  if (isFiltering) {
    const [serializedProductCards] = await Promise.all([
      Promise.all(products.map((product) => serializeProductCard(product, locale))),
    ])

    return serializedProductCards
  }

  // If we are not filtering, we need to serialize pushesEdito and the product cards as well
  const indexIncrement = (currentPage - 1) * PRODUCTS_PER_PAGE

  const [serializedProductCards, serializedPushesEdito] = await Promise.all([
    Promise.all(products.map((product) => serializeProductCard(product, locale))),
    Promise.all(
      pushesEditoInCurrentPage.map(async (pushEdito) => ({
        index: pushEdito.position_in_grid - indexIncrement - 1,
        value: await serializePushEdito(pushEdito, locale),
      }))
    ),
  ])

  const productsAndPushes = insertItemsByIndex(serializedProductCards, serializedPushesEdito)

  return productsAndPushes
}
